import React from 'react'
import type { Message } from '../types'
import UserMessage from './UserMessage'
import AIMessage from './AIMessage'

interface MessageListProps {
  messages: Message[]
  isLoading: boolean
  messagesPage: number
  onScroll: () => void
  messagesScrollRef: React.RefObject<HTMLDivElement | null>
  messagesEndRef: React.RefObject<HTMLDivElement | null>
  getFileIcon: (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other') => string
  getFileTypeLabel: (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other') => string
  onCopyAnswer: (text: string) => void
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  isLoading,
  messagesPage,
  onScroll,
  messagesScrollRef,
  messagesEndRef,
  getFileIcon,
  getFileTypeLabel,
  onCopyAnswer
}) => {
  return (
    <div 
      className={`statgpt-messages-container ${messages.length >= 3 ? 'show-scroll' : ''}`}
      ref={messagesScrollRef}
      onScroll={onScroll}
    >
      {isLoading && messagesPage > 0 && (
        <div className="statgpt-messages-loading">Loading older messages...</div>
      )}
      {messages.map((message) => (
        message.type === 'user' ? (
          <UserMessage
            key={message.id}
            message={message}
            getFileIcon={getFileIcon}
            getFileTypeLabel={getFileTypeLabel}
          />
        ) : (
          <AIMessage
            key={message.id}
            message={message}
            onCopy={onCopyAnswer}
          />
        )
      ))}
      <div ref={messagesEndRef} />
    </div>
  )
}

export default MessageList

